export enum UserRoles {
  ENTE = 'ENTE_DI_FORMAZIONE',
  CPI = 'CPI',
  REGIONE = 'REGIONE',
  CITTADINO = 'CITTADINO',
  DOCENTE = 'DOCENTE',
  PRESIDENTE = 'PRESIDENTE_COMMISSIONE',
  TUTOR = 'TUTOR',
}
